import {Directive} from '@angular/core';

@Directive({
  selector: '[genTableEmpty]',
  standalone: true
})
export class GenericTableEmptyTemplateDirective {
}
